import React, { useState } from 'react';
import { useFloating } from '@floating-ui/react-dom';
import { offset, flip, shift } from '@floating-ui/react-dom';
import Clickable from '../../../components/Clickable';
import Portal from '../../../components/Portal';

interface CallDropdownProps {
  onVideoCall: () => void;
  onAudioCall: () => void;
  isMobile?: boolean;
}

export const CallDropdown: React.FC<CallDropdownProps> = ({ 
  onVideoCall, 
  onAudioCall, 
  isMobile = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  }

  // Floating UI Hook to calculate positioning
  const { x, y, strategy, refs } = useFloating({
    placement: "bottom-end",
    middleware: [offset(8), flip(), shift()],
  });

  const handleVideoCall = (e: React.MouseEvent) => {
    e.stopPropagation();
    onVideoCall();
    setIsOpen(false);
  };

  const handleAudioCall = (e: React.MouseEvent) => {
    e.stopPropagation();
    onAudioCall();
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block">
      <Clickable 
        ref={refs.setReference}
        className="cursor-pointer flex items-center justify-center rounded-xl h-[50px]" 
        onClick={handleClick}
        style={{ width: isMobile ? '35px' : '50px'}}
      >
        <span className="material-icons text-brand-orange text-[30px]">call</span>
      </Clickable>

      {isOpen && (
        <Portal 
          isOpen={isOpen} 
          onClose={() => setIsOpen(false)}
          className="fixed"
        >
          <div
            ref={refs.setFloating}
            style={{
              position: strategy,
              top: y ?? 0,
              left: x ?? 0,
            }}
            className="w-40 bg-brand-bg-2 rounded-xl p-3"
          >
            <div
              className="flex items-center w-full px-3 py-2 hover:bg-brand-bg-3 cursor-pointer rounded-lg"
              onClick={handleAudioCall}
            >
              <i className="material-symbols-outlined text-[18px] mr-2 text-brand-orange">
                call
              </i>
              <span className="text-sm text-brand-text-2">
                Audio Call
              </span>
            </div>
            <div
              className="flex items-center w-full px-3 py-2 hover:bg-brand-bg-3 cursor-pointer rounded-lg"
              onClick={handleVideoCall}
            >
              <i className="material-symbols-outlined text-[18px] mr-2 text-brand-orange">
                videocam
              </i>
              <span className="text-sm text-brand-text-2">
                Video Call
              </span>
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};